import { HelpFunctions, LabelFunctions } from '../types';
import { CoreActivityItemModel } from '../../api/models';

export const alternateOtherOrganisationName = (values: Partial<CoreActivityItemModel>, defaultLabel: string) => {
    switch (values.otherOrganisation) {
        case 'YesCRC':
            return 'Which Cooperative Research Centre conducted some or all of this activity?';
        case 'YesRSP':
            return 'Which Research Service Provider conducted some or all of this activity?';
        case 'YesRSPLevy':
            return 'Which Research Service Provider conducted some or all of this activity?';
    }
    return defaultLabel;
};

export const alternateBriefDescription = (values: Partial<CoreActivityItemModel>, defaultLabel: string) => {
    switch (values.otherOrganisation) {
        case 'YesCRC':
            return `A brief description of the services provided by the Cooperative Research Centre.`;
        case 'YesRSP':
            return `A brief description of the services provided by the Research Service Provider.`;
        case 'YesRSPLevy':
            return `A brief description of the services provided by the Research Service Provider.`;
    }
    return defaultLabel;
};

export const alternatePurpose = (values: Partial<CoreActivityItemModel>, defaultLabel: string) => {
    if (values.futureCoreActivity === 'Yes') {
        return 'Will you conduct this core R&D activity for a substantial purpose of generating new knowledge?';
    }
    return defaultLabel;
};

export const alternateNewKnowledge = (values: Partial<CoreActivityItemModel>, defaultLabel: string) => {
    if (values.futureCoreActivity === 'Yes') {
        return 'What new knowledge is this core R&D activity intended to produce?';
    }
    return defaultLabel;
};

const estimatedExpenditureYearLabel = (defaultLabel: string, financialYearLabel: string | undefined) => {
    if (financialYearLabel) {
        return `Anticipated expenditure income year ${financialYearLabel}`;
    }
    return defaultLabel;
};

export const expenditurePriorToYear1 = (values: Partial<CoreActivityItemModel>, defaultLabel: string) => {
    if (values) {
        return `Expenditure incurred prior to ${values.financialYear1}`;
    }
    return defaultLabel;
};

export const financialYear1EstimatedExpenditure = (values: Partial<CoreActivityItemModel>, defaultLabel: string) => {
    return estimatedExpenditureYearLabel(defaultLabel, values.financialYear1);
};

export const financialYear2EstimatedExpenditure = (values: Partial<CoreActivityItemModel>, defaultLabel: string) => {
    return estimatedExpenditureYearLabel(defaultLabel, values.financialYear2);
};

export const financialYear3EstimatedExpenditure = (values: Partial<CoreActivityItemModel>, defaultLabel: string) => {
    return estimatedExpenditureYearLabel(defaultLabel, values.financialYear3);
};

export const financialYear3EstimatedExpenditurePost = (values: Partial<CoreActivityItemModel>, defaultLabel: string) => {
    if (values) {
        return `Anticipated expenditure post ${values.financialYear3}`;
    }
    return defaultLabel;
};

export const coreActivities: LabelFunctions<CoreActivityItemModel> = {
    otherOrganisationName: alternateOtherOrganisationName,
    briefDescription: alternateBriefDescription,
    // purpose: alternatePurpose,
    // newKnowledge: alternateNewKnowledge,
    expenditurePriorToYear1,
    financialYear1EstimatedExpenditure,
    financialYear2EstimatedExpenditure,
    financialYear3EstimatedExpenditure,
    financialYear3EstimatedExpenditurePost,
};

export const alternateCoreActivityContentKeys = (values: Partial<CoreActivityItemModel>, defaultContentKeys: string[]) => {
    if (values.otherOrganisation === 'YesCRC') {
        return defaultContentKeys.map(key => (
            key === 'CoreActivityBriefDescription' ? 'CoreActivityBriefDescriptionFuture' :
            key === 'CoreActivityConductedByRspName' ? 'CoreActivityConductedByCrcName' : key
        ));
    }

    return defaultContentKeys;
};

export const coreActivitiesHelp: HelpFunctions<CoreActivityItemModel> = {
    contentKeys: alternateCoreActivityContentKeys,
};
